import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextArea, ContextualAlert } from '@paypalcorp/pp-react';
import templateData from '../../../utility/getTemplateData';
import { byteLength } from '../../utilsV3/clientValidatorUtils';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';

const TextAreaWithByteCounter = (props) => {
  const {
    meta: { error, active },
  } = props;
  const initialByteCount = props.input.value
    ? byteLength(props.input.value)
    : 0;
  const [byteCount, setByteCount] = useState(initialByteCount);
  useEffect(() => {
    setByteCount(byteLength(props.input.value));
  }, [props.input.value]);
  const textAreaEl = useRef(null);

  const directionality = templateData.contextLocalityDir;
  const maxByteLimit = props.maxByteLimit;
  const counterAriaLabel = props.counterLabel
    .replace('{byteCount}', byteCount)
    .replace('{maxByteCount}', maxByteLimit);
  const errorText = error,
    hasError = errorText;

  const handleChange = (event) => {
    const value = event.target.value;
    const byteLengthOfValue = byteLength(value);
    setByteCount(byteLengthOfValue);
    props.input.onChange(event);
  };

  useEffect(() => {
    if (hasError && !active) {
      trackEventWithData(FPTI_SPEC.FIELD_LEVEL_ERROR_IM, {
        error_code: 'INPUT_FIELD_VALIDATION_ERROR',
        error_desc: props.id,
        error_detail: errorText,
      });
    }
  }, [hasError]);

  return (
    <div className="text-input-byte-counter">
      <div
        className={`textarea-counter-wrapper ${
          hasError ? 'textarea-counter-wrapper-error' : ''
        }`}
      >
        <TextArea
          label={props.textLabel}
          maxRows={2}
          minRows={2}
          maxCharacters={maxByteLimit}
          dir={directionality}
          value={props.input.value}
          onChange={handleChange}
          className="textarea-holder"
          ref={textAreaEl}
          id={props.id}
        />
        <div
          className={`counter-text ${hasError ? 'counter-text-error' : ''}`}
          role="status"
          aria-label={counterAriaLabel}
          onClick={() => textAreaEl.current.focus()}
        >
          {`${byteCount}/${maxByteLimit}`}
        </div>
      </div>
      {hasError && (
        <ContextualAlert type="error" className="byte-text-area-error">
          {errorText}
        </ContextualAlert>
      )}
    </div>
  );
};

TextAreaWithByteCounter.propTypes = {
  input: PropTypes.object,
  maxByteLimit: PropTypes.number,
  counterLabel: PropTypes.string,
  errorMsg: PropTypes.string,
  textLabel: PropTypes.string,
  id: PropTypes.string,
  meta: PropTypes.object,
};

export default TextAreaWithByteCounter;
